module.exports = __webpack_public_path__ + "media/images/flags/gb-sct-bd4e79de96a6c895b8cbbe65e6504571.svg";